import { render, staticRenderFns } from "./NavbarText.vue?vue&type=template&id=4f682f76&"
import script from "./NavbarText.vue?vue&type=script&lang=js&"
export * from "./NavbarText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports